import { copyStyles } from "./style.js";

const Style = {
  copyStyles
};

export default Style;
